import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { DeleteClientIdentityApiMutationResponse, DeleteClientIdentityApiPathParams, DeleteClientIdentityApi404 } from "../types/DeleteClientIdentityApi";
import type { UseMutationOptions } from "@tanstack/react-query";

 type DeleteClientIdentityApiClient = typeof client<DeleteClientIdentityApiMutationResponse, DeleteClientIdentityApi404, never>;
type DeleteClientIdentityApi = {
    data: DeleteClientIdentityApiMutationResponse;
    error: DeleteClientIdentityApi404;
    request: never;
    pathParams: DeleteClientIdentityApiPathParams;
    queryParams: never;
    headerParams: never;
    response: DeleteClientIdentityApiMutationResponse;
    client: {
        parameters: Partial<Parameters<DeleteClientIdentityApiClient>[0]>;
        return: Awaited<ReturnType<DeleteClientIdentityApiClient>>;
    };
};
/**
 * @summary Delete API Key
 * @link /api/clients/:clientCode/identities/apikeys/:identityId
 */
export function useDeleteClientIdentityApi(clientCode: DeleteClientIdentityApiPathParams["clientCode"], identityId: DeleteClientIdentityApiPathParams["identityId"], options: {
    mutation?: UseMutationOptions<DeleteClientIdentityApi["response"], DeleteClientIdentityApi["error"], DeleteClientIdentityApi["request"]>;
    client?: DeleteClientIdentityApi["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<DeleteClientIdentityApi["data"], DeleteClientIdentityApi["error"], DeleteClientIdentityApi["request"]>({
                method: "delete",
                url: `/api/clients/${clientCode}/identities/apikeys/${identityId}`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}